.button {
	display: inline-flex;
	gap: var(--spacing-2);
	align-items: center;
	justify-content: center;
	font-family: inherit;
	font-weight: var(--font-weight-medium);
	letter-spacing: 0.02em;
	text-decoration: none;
	cursor: pointer;
	border: 1px solid transparent;
	border-radius: var(--radius-md);
	transition:
		background-color var(--motion-fast) var(--ease-standard),
		border-color var(--motion-fast) var(--ease-standard);

	&:disabled {
		cursor: not-allowed;
		opacity: 0.5;
	}

	/* Press feedback for every variant — nudge down on click (primary also darkens
	   its background via its own :active). */
	&:active:not(:disabled) {
		transform: translateY(1px);
	}

	/* Size — driven by the data-size prop */
	&[data-size='small'] {
		min-block-size: 2rem;
		padding: 0 var(--spacing-3);
		font-size: var(--font-size-sm);
	}

	&[data-size='medium'] {
		min-block-size: 2.5rem;
		padding: 0 var(--spacing-4);
		font-size: var(--font-size-base);
	}

	&[data-size='large'] {
		min-block-size: 3rem;
		padding: 0 var(--spacing-5);
		font-size: var(--font-size-lg);
	}

	/* Variant — driven by the data-variant prop */

	/* The kiss.cat marketing CTA look: a violet gradient that lifts on hover
	   (brightness + a taller glow) and presses in on click. */
	&[data-variant='primary'] {
		color: var(--colour-text-on-brand);
		background: var(--colour-brand-gradient);
		box-shadow: var(--colour-brand-elevation);
		transition:
			transform var(--motion-fast) var(--ease-standard),
			filter var(--motion-fast) var(--ease-standard),
			box-shadow var(--motion-fast) var(--ease-standard);

		&:hover {
			box-shadow: var(--colour-brand-elevation-hover);
			filter: brightness(1.07);
		}

		/* Overrides the shared translateY nudge with the marketing scale press. */
		&:active:not(:disabled) {
			filter: brightness(1.07);
			transform: scale(0.97);
		}
	}

	&[data-variant='secondary'] {
		color: var(--colour-text-primary);
		background-color: var(--colour-background-surface);
		border-color: var(--colour-border-strong);

		&:hover {
			border-color: var(--colour-text-secondary);
		}
	}

	/* Between secondary and ghost: a resting surface so low-emphasis actions
	   (card quick-actions, row controls) still read as buttons, not links. */
	&[data-variant='subtle'] {
		color: var(--colour-text-secondary);
		background-color: var(--colour-background-page);
		border-color: var(--colour-border-subtle);

		&:hover {
			color: var(--colour-text-primary);
			background-color: var(--colour-background-surface);
			border-color: var(--colour-border-strong);
		}
	}

	/* Destructive tone, composable with any variant via data-tone. */
	&[data-tone='danger'] {
		color: var(--colour-danger);

		&:hover {
			color: var(--colour-danger);
			border-color: var(--colour-danger);
		}
	}

	&[data-variant='ghost'] {
		color: var(--colour-text-primary);
		background-color: transparent;

		&:hover {
			background-color: var(--colour-background-page);
		}
	}
}
